import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PersonalBrand from "@/pages/PersonalBrand";
import AdminInbox from "@/pages/AdminInbox";
import CaseStudy from "@/pages/CaseStudy";
import InsightPost from "@/pages/InsightPost";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PersonalBrand />} />
                    <Route path="/admin" element={<AdminInbox />} />
                    <Route path="/admin/inbox" element={<AdminInbox />} />
                    <Route path="/case/:slug" element={<CaseStudy />} />
                    {/* Archived — not publishing yet. Re-enable when ready:
                    <Route path="/insights/:slug" element={<InsightPost />} /> */}
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#111111",
                        color: "#F4F4F0",
                        border: "1px solid #333333",
                        borderRadius: 0,
                        fontFamily: "'IBM Plex Mono', monospace",
                        fontSize: "13px",
                    },
                }}
            />
        </div>
    );
}

export default App;
